<template lang="pug">
//- we'll give a little padding on the sides to account for the handle widths
.v-range-slider.px-3.pb-4
  //- Set last grid element to 0px, then manually position text to fall on last pip
  ul.grid.text-center.text-xs.mb-6(:style="`grid-template-columns: repeat(${ticks.length - 1}, minmax(0, 1fr)) 0px`")
    template(v-for="(tick, index) in ticks")
      li.pip(v-if="index < ticks.length - 1")
        .pip-translate.text-xs.text-gray-850 {{ labels[index] }}
      li.pip.relative(v-else)
        .pip-translate.text-xs.text-gray-850.absolute {{ labels[index] }}
  div(ref="sliderRef")
</template>

<script lang="ts" setup>
import noUiSlider from 'nouislider'
import type { PropType } from 'vue'

const props = defineProps({
  ticks: {
    required: false,
    type: Array as PropType<number[]>,
    default: () => [0, 10, 100, 1000],
  },
  margin: {
    required: false,
    type: Number,
    default: 0,
  },
  labels: {
    required: false,
    type: Array as PropType<string[]>,
    default: () => [],
  },
  start: {
    required: false,
    type: Array as PropType<number[]>,
    // start and end range, defined by index of the ticks
    default: () => [0, 2],
  },
})
const emit = defineEmits(['update'])
const sliderRef = ref<any>(null)

watch(
  () => props.start,
  () => {
    const el = sliderRef.value
    el?.noUiSlider.set(props.start)
  }
)

onMounted(() => {
  const el = sliderRef.value

  noUiSlider.create(el, {
    start: props.start,
    margin: props.margin,
    step: 1,
    connect: true,
    range: {
      min: [0],
      max: [props.ticks.length - 1],
    },
  })

  el?.noUiSlider.on('change', ([min, max]: [string, string]) =>
    emit('update', {
      min: props.ticks[parseInt(min)],
      max: props.ticks[parseInt(max)],
    })
  )
})
</script>

<style lang="stylus">
@import '~/assets/css/nouislider.css'
</style>

<style lang="stylus" scoped>
.pip-translate
  transform: translateX(-50%)
</style>
